import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
    NOT_FOUND_BACK_LABEL_KEY,
    NOT_FOUND_BACK_ROUTE,
} from '../../tokens/not-found-route.token';
import { ErrorPageComponent } from '../error-page/error-page.component';

@Component({
    selector: 'apcam-not-found',
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ErrorPageComponent, MatButtonModule, RouterLink, TranslatePipe],
})
export class NotFoundComponent {
    protected readonly backLabel = inject(NOT_FOUND_BACK_LABEL_KEY);
    protected readonly backRoute = inject(NOT_FOUND_BACK_ROUTE);
}
